import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { DocumentRequest } from "../v1/DocumentRequest";
import {
  MrfiktivCreateDocumentRequestDtoGen,
  MrfiktivDocumentRequestControllerFindAllParamsGen,
  MrfiktivUpdateDocumentRequestDtoGen
} from "../v1/data-contracts";

class DocumentRequestService {
  mrfiktivProxy: DocumentRequest;

  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new DocumentRequest(mrfiktivHttpClientProvider.client());
  }

  async create(partnerId: string, data: MrfiktivCreateDocumentRequestDtoGen) {
    const result = (await this.mrfiktivProxy.documentRequestControllerCreate(partnerId, data)).data;
    return result;
  }

  async get(data: MrfiktivDocumentRequestControllerFindAllParamsGen) {
    const result = (await this.mrfiktivProxy.documentRequestControllerFindAll(data)).data;
    return result;
  }

  async getOne(partnerId: string, id: string) {
    const result = (await this.mrfiktivProxy.documentRequestControllerGetOne(partnerId, id)).data;
    return result;
  }

  async update(partnerId: string, id: string, data: MrfiktivUpdateDocumentRequestDtoGen) {
    const result = (await this.mrfiktivProxy.documentRequestControllerUpdate(partnerId, id, data)).data;
    return result;
  }

  async delete(partnerId: string, id: string) {
    const result = (await this.mrfiktivProxy.documentRequestControllerDelete(partnerId, id)).data;
    return result;
  }
}

export default new DocumentRequestService(new MrfiktivHttpClientProvider());
